module.exports = __webpack_public_path__ + "static/media/guessingScreenshot1.53a9ded7.png";